module.exports = __webpack_public_path__ + "img/video_speed.eed23d36.svg";